<template>
  <section>
    <div class="a-row" v-for="session in match.sessions" :key="session.$index">
      <div class="sub-title sticky top60 center">{{session.key | capitalise}}</div>
      <div v-for="timeline in session.items" :key="timeline.key">
        <div v-if="timeline.team" class="fullwidth hoveritem">
          <div class="part-first noborder">
            <span v-if="timeline.team == 'a'">
              <span>{{timeline.comment}} </span>
              <span class="tag" :class="timeline.kind">{{timeline.kind | capitalise}}</span>
            </span>
          </div>
          <div class="part-middle small">
            <span class="tag"><div>{{timeline.clock.minute}}:{{timeline.clock.second}}'</div> <div>{{timeline.score.a}} - {{timeline.score.b}}</div> </span>
          </div>
          <div class="part-last">
            <span v-if="timeline.team == 'b'">
              <span class="tag" :class="timeline.kind">{{timeline.kind | capitalise}}</span>
              <span>{{timeline.comment}}</span>
            </span>
          </div>
        </div>
        <div v-else class="fullwidth">
          <span class="tag">{{timeline.kind | capitalise}}</span> {{timeline.comment}}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    match: Object
  }
}
</script>
